import React from 'react'
import PropTypes from 'prop-types'
import { Snackbar, Alert } from '@mui/material'

import './CSnackbar.css'
import { useDispatch, useSelector } from 'react-redux'
import { setSnackBarStates } from '../../features/ui/uiSlice'

const CSnackbar = ({
    open = false,
    onClose,
    message = '',
    severity = 'success',
    autoHideDuration = 6000,
    position = { vertical: 'top', horizontal: 'right' },
    className = '',
    ...props
}) => {
    const dispatch = useDispatch();

    const snackbar = useSelector(state => state.ui.snackBarStates);

    const handleClose = () => {
        dispatch(setSnackBarStates({
            message: '',
            severity: '',
            open: false,
            autoHideDuration: 5000,
            icon: ''
        }));
    }

    return (
        <Snackbar
            open={snackbar.open || open}
            autoHideDuration={snackbar.autoHideDuration || autoHideDuration}
            onClose={handleClose}
            anchorOrigin={position}
            className={`c-snackbar ${className}`}
            {...props}
        >
            <Alert
                onClose={handleClose}
                severity={snackbar.severity || severity}
                sx={{ width: '100%' }}
                className="c-snackbar-alert"
            >
                {snackbar.message || message}
            </Alert>
        </Snackbar>
    )
}

export default CSnackbar
